// Entity name keys (used for state lookups)
export const STAFFING_ROLES = 'staffingRoles'
export const RATINGS = 'ratings'
export const SKILLS = 'skills'
export const ENGAGEMENTS = 'engagements'
export const PLACEMENTS = 'placements'
export const SPONSORSHIPS = 'sponsorships'
export const SPONSORS = 'sponsors'
export const USERS = 'users'

// Engagement statuses
export const SQL = 'SQL'
export const LEAD = 'Lead'
export const SALES_QUALIFIED_LEAD = 'SQL (Sales Qualified Lead)'
export const DISQUALIFIED = 'Disqualified'
export const SOLUTION_DESIGN = 'Solution Design'
export const PROPOSAL = 'Proposal'
export const PARTIAL_BANF = 'Partial BANF'
export const CONTRACTING = 'Contracting'
export const CLOSED_WON = 'Closed - Won'
export const CLOSED_LOST = 'Closed - Lost'
export const WON = 'Won'

export const ACTIVE_ENGAGEMENT_STATUSES = [
  SQL,
  LEAD,
  SALES_QUALIFIED_LEAD,
  SOLUTION_DESIGN,
  PROPOSAL,
  PARTIAL_BANF,
  CONTRACTING,
  CLOSED_WON,
  WON,
]

export const CLOSED_WON_ENGAGEMENT_STATUSES = ['Closed - Won', 'Won']

// User types
export const EMPLOYEE_TYPE_EMPLOYEE = 'Employee'
export const EMPLOYEE_TYPE_PARTNER = 'Partner'
export const EMPLOYEE_ACCESS_OPTIONS = ['user', 'admin', 'third party']

// Placement statuses
export const PLACED = 'Placed'
export const PROPOSED = 'Proposed'
export const NOT_PROPOSED = 'Not Proposed'
export const STRIDER_CONFIRMED = 'Strider Confirmed'
export const CLIENT_CONFIRMED = 'Client Confirmed'

export const PLACEMENT_STATUSES = [
  NOT_PROPOSED,
  PROPOSED,
  STRIDER_CONFIRMED,
  CLIENT_CONFIRMED,
  PLACED,
]

export const PLACEMENT_STATUSES_ENUM = {
  NOT_PROPOSED,
  PROPOSED,
  STRIDER_CONFIRMED,
  CLIENT_CONFIRMED,
  PLACED,
}

export const NON_STAFFABLE_ENGAGEMENT_STATUSES = ['Disqualified', 'Closed - Lost']

// Entity map (for store lookups by name)
export const ENTITIES = {
  ACTIVE_CLIENTS_BY_ID: 'activeClientsById',
  CLIENTS: 'clients',
  CLIENTS_BY_ID: 'clientsById',
  ENGAGEMENTS,
  ENGAGEMENTS_BY_ID: 'engagementsById',
  FEATURES: 'features',
  STAFFING_ROLES,
  STAFFING_ROLES_BY_ID: 'staffingRolesById',
  PLACEMENTS,
  RATINGS,
  SKILLS,
  SPONSORSHIPS,
  SPONSORS,
  USERS,
}

export const CONSULTANT_TIERS = new Set([0, 1, 2, 3, 4, 5, 6, 7])
